module.exports = __webpack_public_path__ + "img/innominada.3492809f.png";